<template>
  <div class="bg">
    <div class="mt20">
      <span>结算周期:</span><span class="ml10">{{settlementTime}}</span>
      <span style="margin-left: 80px">发放代理商:</span><span class="ml10">{{sendAgent}}</span>
    </div>
    <!--<div class="flex flex-end item-center">
      <div>
        <div class="delete mr20 pointer">
          <span class="delete-icon hmicon icon-daochu"></span>
          导出结算表
        </div>
      </div>
    </div>-->
    <div>
      <el-table
          :data="list"
          :span-method="objectSpanMethod"
          show-summary
          :summary-method="getSummaries"
          border
          style="width: 100%; margin-top: 20px">
        <el-table-column
            prop="supplierName"
            label="供货商"
            header-align="center"
            align="center"
            >
        </el-table-column>
        <el-table-column
            prop="feeMoney"
            header-align="center"
            align="center"
            label="服务费">
          <template slot-scope="scope">
            <div class="flex flex-column flex-center">
              <div>{{ scope.row.percentageRatio }}%</div>
              <div>最低{{ scope.row.nadirMoney }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
            prop="storeName"
            header-align="center"
            align="center"
            label="商户">
        </el-table-column>
        <el-table-column
            prop="billNum"
            header-align="center"
            align="center"
            label="小票数量(单)">
        </el-table-column>
        <el-table-column
            prop="tradeMoney"
            header-align="center"
            align="center"
            label="小票红包金额(元)">
          <template slot-scope="scope">
            ¥<span>{{scope.row.tradeMoney}}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="feeMoney"
            header-align="center"
            align="center"
            label="支付服务费(元)">
          <template slot-scope="scope">
            ¥<span>{{scope.row.feeMoney}}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="totalTradeMoney"
            header-align="center"
            align="center"
            label="供应商合计支出(元)">
          <template slot-scope="scope">
            ¥<span>{{scope.row.totalTradeMoney}}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="perFeeMoney"
            header-align="center"
            align="center"
            label="单笔平均服务费(元)">
          <template slot-scope="scope">
            ¥<span>{{scope.row.perFeeMoney}}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="feeMoneyPercent"
            header-align="center"
            align="center"
            label="平均服务费比(元)">
          <template slot-scope="scope">
            <span>{{scope.row.feeMoneyPercent}}</span>%
          </template>
        </el-table-column>
        <el-table-column
            prop="refundTradeMoney"
            header-align="center"
            align="center"
            label="退单红包金额(元)">
          <template slot-scope="scope">
            ¥<span>{{scope.row.refundTradeMoney}}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="refundFeeMoney"
            header-align="center"
            align="center"
            label="退单服务费(元)">
          <template slot-scope="scope">
            ¥<span>{{scope.row.refundFeeMoney}}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="serviceProfit"
            header-align="center"
            align="center"
            label="代理分润(元)">
          <template slot-scope="scope">
            ¥<span>{{scope.row.serviceProfit}}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="serviceProfitRatio"
            header-align="center"
            align="center"
            label="代理分润占比">
          <template slot-scope="scope">
            <span>{{scope.row.serviceProfitRatio}}</span>%
          </template>
        </el-table-column>
        <el-table-column
            prop="hemiaoProfit"
            header-align="center"
            align="center"
            label="禾苗净利润(元)">
          <template slot-scope="scope">
            ¥<span>{{scope.row.hemiaoProfit}}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="settlementTime"
            header-align="center"
            align="center"
            label="交易周期">
          <template>
            <span>{{ settlementTime }}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="serviceProfitTotal"
            header-align="center"
            align="center"
            label="佣金小计(元)">
          <template slot-scope="scope">
            ¥<span>{{scope.row.serviceProfitTotal}}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div  class="dialog-footer flex flex-center mt20" v-if="showAudit">
      <el-button type="primary" style="border-color: #FF7F10;" class="orange-bg" size="small" @click="guaQiDialog = true">
        挂起</el-button
      >
      <el-button type="success" size="small" @click="auditSucc">
        审批通过</el-button
      >
    </div>
    <div  class="dialog-footer flex flex-center mt20" v-if="showDaKuan">
      <el-button type="primary" style="border-color: #FF7F10;" class="orange-bg" size="small" @click="doGuaqi">
        挂起</el-button
      >
      <el-button type="success" size="small" @click="daKuanDialog = true">
        确认打款</el-button
      >
    </div>
    <el-dialog :visible.sync="guaQiDialog" :title="'确认挂起'" :modal-append-to-body="false" :append-to-body="true" width="580px">
      <el-form :model="guaQiForm" :rules="rules" ref="guaQiForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="挂起备注" prop="desc">
          <el-input type="textarea" v-model="guaQiForm.desc" placeholder="请输入挂起备注" style="width: 80%"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer flex flex-center mt20">
        <el-button type="primary" size="small" @click="toGuaqi">
          提交</el-button
        >
        <el-button type="info" size="small" @click="guaQiDialog = false">
          取消</el-button
        >
      </div>
    </el-dialog>

    <el-dialog :visible.sync="daKuanDialog" :title="'确认打款'" :modal-append-to-body="false" :append-to-body="true" width="580px">
      <el-form :model="daKuanForm" :rules="rules" ref="daKuanForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="发放代理商" >
         <span>{{ sendAgent }}</span>
        </el-form-item>
        <el-form-item label="结算周期" prop="desc">
          <span>{{ settlementTime }}</span>
        </el-form-item>
        <el-form-item label="结算金额" prop="desc">
          <span>￥{{ totalMoney }}</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer flex flex-center mt20">
        <el-button type="primary" size="small" @click="toDaKuan">
          提交</el-button
        >
        <el-button type="info" size="small" @click="daKuanDialog = false">
          取消</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "RedPackageSettlement",
  props: {
    settlementTime: {type: String},
    sendAgent: {type: String},
    id: {type: String},
    totalMoney: {type: String},
    showAudit: {type: Boolean, default: true},
    showDaKuan: {type: Boolean, default: false}
  },
  data() {
    return {
      list: [],
      guaQiDialog: false,
      guaQiForm: {},
      rules: {},
      daKuanDialog: false,
      daKuanForm: {
        method: 1
      },
      daKuanMethod: [
        {
          label: "微信支付",
          value: 1
        }
      ]
    }
  },
  created() {
    this.queryList();

  },
  mounted() {},
  methods: {
    doGuaqi() {
      this.guaQiForm = {
        desc:""
      };
      this.guaQiDialog = true;
    },
    //审批通过
    auditSucc() {
      let params = {
        settleSn: this.id,
        settleState: "confirmWait"
      };
      this.doAudit(params);
    },
    //打款
    toDaKuan() {
      let params = {
        settleSn: this.id,
        settleState: "settle"
      };
      this.doAudit(params);
    },
    //挂起
    toGuaqi() {
      let params = {
        settleSn: this.id,
        settleState: "hang",
        remark: this.guaQiForm.desc
      };
      this.doAudit(params);
    },
    async doAudit(params) {
      await this.$store.dispatch("settleAudit", params);
      this.$message({
        message: "操作成功",
        type: "success"
      });
      this.daKuanDialog = false;
      this.guaQiDialog = false;
      this.$emit("closeDialog");
    },
    //查询数据
    async queryList() {
      console.log("id", this.id);
      const params = {
        settleSn: this.id
      };
      const { code, result } = await this.$store.dispatch("queryAgentSettlementDetail", params);
      console.log(result);
      if (code === "0") {
        this.list = result;
        // 先给所有的数据都加一个v.rowspan = 1
        this.list.forEach(v => {
          v.rowspan = 1;
        });
        // 双层循环
        for (let i = 0; i < this.list.length; i++) {
          // 内层循环，上面已经给所有的行都加了v.rowspan = 1
          // 这里进行判断
          // 如果当前行的id和下一行的id相等
          // 就把当前v.rowspan + 1
          // 下一行的v.rowspan - 1
          for (let j = i + 1; j < this.list.length; j++) {
            //此处可根据相同字段进行合并，此处是根据的id
            if (this.list[i].supplierName === this.list[j].supplierName) {
              this.list[i].rowspan++;
              this.list[j].rowspan--;
            }
          }
          // 这里跳过已经重复的数据
          i = i + this.list[i].rowspan - 1;
        };
      }


     /* // 先给所有的数据都加一个v.rowspan = 1
      this.list.forEach(v => {
        v.rowspan = 1;
      });
      // 双层循环
      for (let i = 0; i < this.list.length; i++) {
        // 内层循环，上面已经给所有的行都加了v.rowspan = 1
        // 这里进行判断
        // 如果当前行的id和下一行的id相等
        // 就把当前v.rowspan + 1
        // 下一行的v.rowspan - 1
        for (let j = i + 1; j < this.list.length; j++) {
          //此处可根据相同字段进行合并，此处是根据的id
          if (this.list[i].ghs === this.list[j].ghs) {
            this.list[i].rowspan++;
            this.list[j].rowspan--;
          }
        }
        // 这里跳过已经重复的数据
        i = i + this.list[i].rowspan - 1;
      };*/

    },
    //合并单元格
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 1) {
        return {
          rowspan: row.rowspan,
          colspan: 1
        };
      }
    },
    //合计
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (index === 2) {
          sums[index] = data.length;
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          if (index > 3) {
            if (index === 12 || index === 8) {
              sums[index] += " %";
            } else {
              sums[index] = '¥ ' + sums[index];
            }
          }
        }
      });

      return sums;
    }
  }
}
</script>

<style scoped lang="scss">
.bg {
  background: #fff;
}
</style>